import FormInvite from './FormInvite';
import FormNumber from './FormNumber';
import FormSMS from './FormSMS';
import FormPasswordRestore from './FormPasswordRestore';
import FormNotConnected from './FormNotConnected';
import FormRegistration from './FormRegistration/FormRegistration';
import FormTechnicalProblem from './FormTechnicalProblem/FormTechnicalProblem';

export { FormRegistration, FormTechnicalProblem };

export default {
  FormInvite,
  FormNumber,
  FormSMS,
  FormPasswordRestore,
  FormNotConnected
};



// WEBPACK FOOTER //
// ./src/components/Login/index.js